import {
  Goal,
  GoalDeadlineRowsMap,
  GoalProgressCount,
  GoalTreeIndex,
  ID,
  IDPrefixes,
  LifeArea,
} from '@griply/types';

import { createCompositeId } from './encoded-ids/composite-id';
import { getGoalCompletionPercentage } from './get-goal-completion-percentage';
import { getLinkedItemColor } from './get-linked-item-color';

export type BuildGoalDeadlineRowsOptions = {
  goals: Goal[];
  lifeAreas: LifeArea[];
  goalProgressCounts?: Map<ID, GoalProgressCount>;
  goalTreeIndex?: GoalTreeIndex;
};

// Keyed by tree-item id so a row resolves in O(1) instead of scanning goals.
export const buildGoalDeadlineRows = (
  deadlineGoals: Goal[],
  {
    goals,
    lifeAreas,
    goalProgressCounts,
    goalTreeIndex,
  }: BuildGoalDeadlineRowsOptions,
): GoalDeadlineRowsMap =>
  new Map(
    deadlineGoals.map((goal) => [
      createCompositeId(IDPrefixes.GoalDeadline, [goal.id]),
      {
        goal,
        completionPercentage: goal.completedAt
          ? 100
          : getGoalCompletionPercentage(
              goal.id,
              goals,
              goalProgressCounts,
              goalTreeIndex,
            ),
        color: getLinkedItemColor(goal.id, { goals, lifeAreas }),
      },
    ]),
  );
